import { ISectionAvailability } from '../../../interfaces/scheduler_interfaces';
import { ISectionType } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
export class SectionAvailability implements ISectionAvailability {
  static build(sectionType: ISectionType) {
    return new SectionAvailability(sectionType);
  }
  id: number;
  is_seat_available: boolean;
  is_conflicting_with_student_time: boolean;
  is_conflicting_with_student_campus: boolean;
  is_conflicting_with_selected_section: boolean;
  is_conflicting_with_linked_section: boolean;
  conflicting_linked_section_ids: number[];
  conflicting_selected_section_ids: number[];
  avail_seats: number;
  is_waitlist_full: boolean;
  is_waitlist_allowed: boolean;
  is_auto_waitlist: boolean;
  is_conflicting_with_session: boolean;
  cross_course_linked_section: boolean;
  cross_course_linked_section_satisfied: boolean;
  has_linked_section_coreqs: boolean;
  last_refresh_ts: string;
  linked_section_coreqs_satisfied: boolean;
  is_withdrawn: boolean;

  constructor(sectionType: ISectionType) {
    _4.merge(this, sectionType);
    return this;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/builders/section_availability_builder.ts